import React, { useEffect, useState, useCallback } from 'react';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Foto from "../Components/Foto";
import { Line } from 'react-chartjs-2';
import './equipamento.css';
import {
    Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

const Equipamentos = () => {
    const [itens, setItens] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [lojaSelecionada, setLojaSelecionada] = useState(null);
    const [dentroDoRaio, setDentroDoRaio] = useState(false);
    const [loading, setLoading] = useState(true);
    const [analiseData, setAnaliseData] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const permiteRegional = localStorage.getItem("permiteRegional") === 'S' || localStorage.getItem("diretor") === 'S';

    const buscarDados = useCallback(async (codEmp) => {
        setLoading(true);
        try {
            const res = await api.get(`/equipamentos/${codEmp}`);
            setItens(res.data);
        } catch (err) {
            Swal.fire('Erro', 'Erro ao carregar equipamentos.', 'error');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const inicializarComponente = async () => {
            setLoading(true);
            let listaLojas = [];

            try {
                const resp = await api.get("lojas/localizacao");
                listaLojas = resp.data || [];
                setLojas(listaLojas);

                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        async (pos) => {
                            const { latitude, longitude } = pos.coords;
                            const lojaProxima = listaLojas.find((loja) => {
                                const distKm = calcularDistancia(latitude, longitude, parseFloat(loja.latitude), parseFloat(loja.longitude));
                                return (distKm * 1000) <= parseFloat(loja.distancia || 0);
                            });

                            if (lojaProxima) {
                                setLojaSelecionada(lojaProxima);
                                setDentroDoRaio(true);
                            } else {
                                fallbackLocalStorage(listaLojas, "Você não está no raio de nenhuma loja.");
                            }
                        },
                        () => fallbackLocalStorage(listaLojas, "GPS indisponível ou permissão negada."),
                        { timeout: 10000, enableHighAccuracy: true }
                    );
                } else {
                    fallbackLocalStorage(listaLojas, "Geolocalização não suportada.");
                }
            } catch (error) {
                setLoading(false);
            }
        };

        const fallbackLocalStorage = (lista, motivo) => {
            let idLojaSalva = localStorage.getItem("loja");
            if (Number(idLojaSalva) > 36) idLojaSalva = 5;

            const lojaPadrao = lista.find(l => String(l.cod_emp) === String(idLojaSalva));

            if (lojaPadrao) {
                setLojaSelecionada(lojaPadrao);
                setDentroDoRaio(false);
                Swal.fire("Atenção", `${motivo} Usando loja padrão do perfil.`, "info");
            } else {
                setLoading(false);
                Swal.fire("Erro", "Não foi possível identificar sua loja.", "error");
            }
        };

        inicializarComponente();
    }, []);

    useEffect(() => {
        if (lojaSelecionada) {
            buscarDados(lojaSelecionada.cod_emp);
        }
    }, [lojaSelecionada, buscarDados]);

    const handleSalvar = async (idEquip, valor) => {
        if (!valor && valor !== 0) return;
        setLoading(true);
        try {
            await api.post('/equipamentos/contagem', {
                id_loja: lojaSelecionada.cod_emp,
                id_equip: idEquip,
                qtd_contada: parseInt(valor)
            });
            Swal.fire({ title: 'Sucesso!', icon: 'success', timer: 1500, showConfirmButton: false });
            buscarDados(lojaSelecionada.cod_emp);
        } catch (err) {
            setLoading(false);
            Swal.fire('Erro', 'Falha ao salvar contagem', 'error');
        }
    };

    const verAnalise = async (item) => {
        setLoading(true);
        setItemSelecionado(item);
        try {
            const res = await api.get(`/equipamentos/analise/${lojaSelecionada.cod_emp}/${item.id_equip}`);
            const chartData = {
                labels: res.data.map(d => d.data_ref),
                datasets: [{
                    label: 'Saldo em Estoque',
                    data: res.data.map(d => Math.round(d.saldo_final)),
                    borderColor: '#8b0000',
                    backgroundColor: 'rgba(139, 0, 0, 0.15)',
                    tension: 0.3,
                    fill: true
                }]
            };
            setAnaliseData(chartData);
        } catch (err) {
            Swal.fire('Erro', 'Falha ao carregar análise', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Menu modulo="ARBOR" />

            {loading && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(255,255,255,0.9)', zIndex: 99999,
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
                }}>
                    <div className="spinner-border" role="status" style={{ color: '#8b0000', width: '3.5rem', height: '3.5rem' }}></div>
                    <span className="mt-3 fw-bold text-danger italic">Processando, aguarde...</span>
                </div>
            )}

            <div className="container-fluid mt-4 mb-5" style={{ paddingTop: '50px' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12 text-center">
                        <h4 className="mb-4 fw-bold"><i className="fa-solid fa-boxes-stacked me-2 text-danger"></i>Controle de Equipamentos</h4>

                        <div className="mb-3 text-start">
                            <label className="fw-bold small text-muted ms-1">LOJA ATUAL</label>
                            <input
                                className="form-control text-center bg-light fw-bold"
                                value={lojaSelecionada?.razao || "Localizando..."}
                                readOnly
                            />
                        </div>

                        {permiteRegional && (
                            <div className="mb-4 p-3 border rounded-3 bg-white shadow-sm text-start">
                                <label className="small fw-bold text-danger">TROCAR LOJA (MODO GESTÃO):</label>
                                <select
                                    className="form-select mt-1"
                                    value={lojaSelecionada?.cod_emp || ""}
                                    onChange={(e) => {
                                        const novaLoja = lojas.find(l => String(l.cod_emp) === String(e.target.value));
                                        if (novaLoja) {
                                            setLojaSelecionada(novaLoja);
                                            setDentroDoRaio(true);
                                        }
                                    }}
                                >
                                    <option value="">Selecione uma loja...</option>
                                    {lojas.map(l => (
                                        <option key={l.cod_emp} value={l.cod_emp}>{l.razao}</option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {!dentroDoRaio && !loading && !permiteRegional && (
                            <div className="alert alert-warning py-2 small shadow-sm">
                                ⚠️ Lançamentos desativados por localização.
                            </div>
                        )}
                    </div>
                </div>

                <div className="row mt-2">
                    {itens.map((item) => (
                        <div className="col-md-4 col-sm-6 col-12 mb-3" key={item.id_equip}>
                            <div className="card shadow-sm border-0 h-100 equipamentos-card">
                                <div
                                    className="text-center bg-light border-bottom"
                                    style={{ height: '180px', overflow: 'hidden', cursor: 'pointer' }}
                                    onClick={() => setFotoSelecionada({
                                        foto: item.foto ? `data:image/jpeg;base64,${item.foto}` : null,
                                        nome: item.descricao,
                                        loja: lojaSelecionada?.razao
                                    })}
                                >
                                    {item.foto ? (
                                        <img src={`data:image/jpeg;base64,${item.foto}`} alt={item.descricao} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                    ) : (
                                        <div className="d-flex align-items-center justify-content-center h-100 text-muted small">Sem foto</div>
                                    )}
                                </div>

                                <div className="card-body d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <h6 className="fw-bold mb-1">{item.descricao}</h6>
                                            <p className="small text-muted mb-0">Saldo: <strong>{item.saldo}</strong></p>
                                        </div>
                                        <button className="btn btn-sm btn-outline-danger border-0 ms-2" onClick={() => verAnalise(item)}>
                                            <i className="fa-solid fa-chart-line"></i>
                                        </button>
                                    </div>

                                    <div className="input-group mt-auto">
                                        <input
                                            key={`input-${item.id_equip}-${item.qtd_hoje}`}
                                            type="number"
                                            className="form-control form-control-sm"
                                            placeholder="Qtd"
                                            id={`input-${item.id_equip}`}
                                            defaultValue={item.qtd_hoje ?? ""}
                                            disabled={(item.qtd_hoje !== null && item.qtd_hoje !== undefined)}
                                        />
                                        <button
                                            className={`btn btn-sm ${item.qtd_hoje !== null ? 'btn-success' : 'btn-danger btn-arbor-primary'}`}
                                            disabled={!dentroDoRaio || (item.qtd_hoje !== null && item.qtd_hoje !== undefined)}
                                            onClick={() => handleSalvar(item.id_equip, document.getElementById(`input-${item.id_equip}`).value)}
                                        >
                                            {item.qtd_hoje !== null ? '✔' : 'Salvar'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal de Gráfico */}
                {analiseData && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 10000 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0 shadow-lg rounded-3">
                                <div className="modal-header modal-header-arbor">
                                    <h5 className="modal-title h6 text-white">{itemSelecionado?.descricao}</h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={() => setAnaliseData(null)}></button>
                                </div>
                                <div className="modal-body" style={{ height: '350px' }}>
                                    <Line data={analiseData} options={{ maintainAspectRatio: false, responsive: true }} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Foto
                    show={!!fotoSelecionada}
                    onClose={() => setFotoSelecionada(null)}
                    foto={fotoSelecionada?.foto}
                    nome={fotoSelecionada?.nome}
                    info01={fotoSelecionada?.loja}
                    info02=""
                />
            </div>
            <Footer />
        </>
    );
};

export default Equipamentos;